import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import global from "./global";
import websock from "./websock";
import course from "./course";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    global,
    websock,
    course
  },
  mutations: {
    CLEAR_STORAGE(state) {
      state.course = {
        moduleId: 0,
        courseId: 0,
        quizId: 0,
        groupId: 0,
        instantId: 0,
        galleryid: 0,
        code: "",
        projection: {
          mode: "",
          fileurl: "",
          filename: ""
        },
        imagePreview: {
          files: [],
          show: false,
          mode: "image"
        },
        mobileInfo: {
          width: 375,
          height: 667
        },
        pptInfo: {
          show: false,
          nowPage: 0,
          galleryid: 0,
          files: []
        },
        raiseHandStudents: [],
        curPage: 0,
        studentsOnlines: []
      };
      state.auth.userinfo = {
        wstoken: "",
        firstname: "",
        lastname: "",
        username: "",
        userid: "",
        userpictureurl: "",
        dateTime: ""
      };
    }
  },
  plugins: [
    createPersistedState({
      path: ["global", "auth", "course"],
      storage: window.localStorage
    })
  ]
});

export default store;
